// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3XDwt","left":"InfoRow_left__i7btm"};